export default [
    {
        title: 'v.0.9.5',
        subtitle: 'August 2020',
        side: 'right',
        icon: false,
        content:
          "Update YouTube Player settings for latest chrome updates.<br>" +
          "Adding HTML5 Section areas for semantic html markup. <br>" +
          "Added Optical odd Series Area coloring. <br>" +
          "Fix loading visual jumping bugs on slow connection. <br>" +
          "Fix Series Overview page coloring issue. <br>" +
          "Fix page background coloring. <br>" +
          "Added Header Clipping Models. <br>" +
          "Added 30% darker overlay to the promoted series. <br>"
    },

    {
        title: 'v.0.9.4',
        subtitle: 'August 2020',
        side: 'left',
        icon: false,
        content:
          "Add Series and Episodes to Sitemap. <br>" +
          "Add validation for report requests.<br>"
    },

    {
        title: 'v.0.9.3',
        subtitle: 'August 2020',
        side: 'right',
        icon: false,
        content:
          "Update Video Player interaction and events. <br>" +
          "Update Video Player data mapping and play conditions. <br>" +
          "Added better error handling on Video Player. <br>" +
          "Added Series Overview with Season and Episodes. <br>" +
          "Added Movement Buttons between Overview and each Episode. <br>" +
          "Added Performance pre-loading feature. <br>" +
          "Added Overlay Buttons for swapping Player modes. <br>" +
          "Added toggleable Fullscreen feature into the Player. <br>" +
          "Added Home Button into Player to get directly into the home. <br>" +
          "Added better navigation usability inbetween videos. <br>" +
          "Added lazy load to Gallery. <br>"
    },

    {
        title: 'v.0.9.2',
        subtitle: 'August 2020',
        side: 'left',
        icon: false,
        content:
          "Added icons to quickly verify validate state of Series. <br>" +
          "Added status icon set for Series and Episodes items. <br>" +
          "Added notification on Validation Status and click events. <br>" +
          "Added intersection on List of Episode for lazy loading. <br>" +
          "Overlay scale of Episodes disabled while loading. <br>" +
          "Add Voting capability for Episodes and Series. <br>"
    },

    {
        title: 'v.0.9.1',
        subtitle: 'August 2020',
        side: 'right',
        icon: false,
        content:
          "Update Episodes in Series with validation option. <br>" +
          "Update Series with validation option. <br>" +
          "Fix KanaX promoted series video id. <br>" +
          "Delete logic for Series and bound seasons with episodes works. <br>"
    },

    {
        title: 'v.0.9.0',
        subtitle: 'August 2020',
        side: 'left',
        icon: false,
        content:
          "YTM|Editor additional Video properties added. <br>" +
          "YTM|Editor feature to copy the Video to the Queue. <br>" +
          "YTM|Editor update Video Card design. <br>" +
          "YTM|Editor added fullscreen feature for the Video Edit Area. <br>" +
          "Create Validate ERM and morph Datastructure for Images, Videos, Series, Episodes.<br>" +
          "Create additional table mutation for validate state of each ERM. <br>" +
          "Add keyup event listener to start search by pressing enter.<br> " +
          "Removed Dummy mode and selections. <br>" +
          "Update YouTube Results Content Area with and optimized layout. <br>"
    },

    {
        title: 'v.0.8.1',
        subtitle: 'August 2020',
        side: 'right',
        icon: false,
        content:
          "Optimizing Build process. <br>" +
          "Optimizing Home with intersections and lazy loading. <br>" +
          "Optimize SEO fallback data. <br>" +
          "Fix layouts and add structured tags. <br>" +
          "Added before loading logic into the gallery. <br>" +
          "Added storage url as proxy to avoid missing images. <br>" +
          "Added a simple thumbnail validation checker. <br>"
    },

    {
        title: 'v.0.8.0',
        subtitle: 'Juli 2020',
        side: 'left',
        icon: false,
        content:
          "Added custom titles to each page. <br>" +
          "Added and fixed manifest file for PWA usage. <br>" +
          "Added SEO optimization with prerendering though middleware. <br>" +
          "Remove static meta tags and let them dynamically generate by prerending. <br>"
    },

    {
        title: 'v.0.7.0',
        subtitle: 'Juli 2020',
        side: 'right',
        icon: false,
        content:
          "Add Preview iFrame for YouTube Video in YTM|Editor. <br>" +
          "Added additional SEO Information. <br>"
    },

    {
        title: 'v.0.6.8',
        subtitle: 'Juli 2020',
        side: 'left',
        icon: false,
        content:
          "Upgrade Homescreen View. <br>" +
          "Change to black theme at Homescreen. <br>" +
          "Add Latest Video to Homescreen. <br>" +
          "Add Latest Episodes to Homescreen. <br>" +
          "Add Latest Series to Homescreen. <br>" +
          "Apply Header Images to home and about. <br>"
    },

    {
        title: 'v.0.6.7',
        subtitle: 'Juni 2020',
        side: 'right',
        icon: false,
        content:
          "UI fix for Series Play Thumbnail. <br>" +
          "Updates for meta og:tags and seo optimization. <br>" +
          "Removing Dummy Mode imports from Editor. <br>" +
          "Adding Sitemaps for SEO performance. <br>"
    },

    {
        title: 'v.0.6.6',
        subtitle: 'Juni 2020',
        side: 'left',
        icon: false,
        content:
          "Fixed Lighthouse Audits. <br>" +
          "Added Sitemap feature. <br>"
    },

    {
        title: 'v.0.6.5',
        subtitle: 'Juni 2020',
        side: 'right',
        icon: false,
        content:
          "Async loading of Kanax Start Data. <br>" +
          "Added new Icons for Modules. <br>" +
          "Added Hover Animation to Series Episodes. <br>" +
          "Added Footer Elements. <br>" +
          "Added privacy and tos pages. <br>"
    },

    {
        title: 'v.0.6.4',
        subtitle: 'Juni 2020',
        side: 'left',
        icon: false,
        content:
          "Add user association for Series, Season and Episodes. <br>" +
          "Fix YTM Gallery sizes. <br> " +
          "Fix YTM Search algorithmus. <br>"
    },

    {
        title: 'v.0.6.3',
        subtitle: 'Juni 2020',
        side: 'right',
        icon: false,
        content:
          "Promoted Component with Season and Episode Information. <br>" +
          "Promoted Component mobile design fixes.<br> " +
          "Mobile fixes for List of Series and Episodes. <br>" +
          "Fixes for description text of kanax. <br>"
    },

    {
        title: 'v.0.6.1',
        subtitle: 'Juni 2020',
        side: 'left',
        icon: false,
        content:
          "Promotion Component filled with information. <br>" +
          "Random Elements for Promotion Component. <br>" +
          "Latest Series list expanded. <br>" +
          "Latest Episodes in random Order. <br>" +
          "List Episodes of Series component. <br>" +
          "Episodes preview can start directly the player. <br>" +
          "Promoted Component with Season and Episode Information. <br>"
    },

    {
        title: 'v.0.6.0',
        subtitle: 'Juni 2020',
        side: 'right',
        icon: false,
        content:
          "Building KanaX frontend. <br>"  +
          "Adding Overlay Colors and new Header to KanaX. <br>" +
          "Updating Promoted Series Component. <br>" +
          "Creating the first simplest iframe player for YouTube. <br>" +
          "Adding navigation back button from the player. <br>"
    },

    {
        title: 'v.0.5.3',
        subtitle: 'Juni 2020',
        side: 'left',
        icon: false,
        content:
          "Adding Videos to Queue. <br>" +
          "Adding movement from selected Queue to Series Queue. <br>" +
          "Saving the Videos as new Episodes. <br>" +
          "Updating existing Episodes with their order. <br>" +
          "Reordering and saving Episodes in Season. <br>" +
          "Fix bug in season delete and current season selection. <br>" +
          "Season deletion with episodes at once. <br>" +
          "Bugfixes in data handling between Series, Season and Episodes. <br>"
    },

    {
        title: 'v.0.5.2',
        subtitle: 'Juni 2020',
        side: 'right',
        icon: false,
        content:
          "Loading Series list and selecting to edit them. <br>" +
          "Loading Series Seasons and patching the Storage data. <br>" +
          "Added Season reordering on update. <br> " +
          "Added Season filtering and update Season data algo. <br>" +
          "Added delete Season request handling. <br>"
    },

    {
        title: 'v.0.5.1',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "Extending technical Information for loaded Series Information. <br>" +
          "Patching Data from YouTube Response Object to the ORM without breaking changes. <br>" +
          "Creating Seasons in the List and add drag & drop support for ordering. <br>" +
          "Adding recalculations for the automaticallyy applyment of the correct order number. <br>" +
          "Adding Season Names properties and matching the correct season order number. <br>" +
          "Adding Series Information validation. <br>" +
          "Adding Season Information validation. <br>" +
          "Adding Episodes Information validation. <br> "
    },

    {
        title: 'v0.5.0',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "Creating new Models and Migrations for the upcomming Series, Season and Episodes. <br>" +
          "Creating new Database Structure in favor of KanaX with Series, Seasons and Episodes. <br>" +
          "Mutating the pre-build Video Structure to Images. <br>" +
          "Breaking Chanes on the Database Structure for KanaX. <br>" +
          "Save new Series based on the YouTube Response Object. <br>" +
          "Switch directly to the edit tab when routing though the edit route. <br>" +
          "Autoload Series based on their UID and map data ORM to Storage. <br> "
    },

    {
        headline: 'Subproject [KanaX] is born',
    },

    {
        title: 'v0.4.7',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "Modify Selected Channel Information. <br>" +
          "Adding search in Channel search function. <br>" +
          "Fixing some pagination bugs and generating dynamic page count. <br>" +
          "Adding notification for Channel overwriting alerts. <br>"
    },

    {
        title: 'v0.4.6',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "Select Channel and show Channel Information. <br> " +
          "Modify gutter spacing from lg to sm for prettier look on the Editors Area. <br>" +
          "Refining selected Videos dragable Elements. <br>" +
          "Extending Dummy Content Elements. <br>" +
          "Fixing Authentication middleware of editors page. <br>" +
          "Adding Notification Messages for erors and hints. <br>" +
          "Fixing pagination building on error responses. <br>"
    },

    {
        title: 'v0.4.5',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "Upgrading mobile view of the YTM|Editor. <br>" +
          "Adding duplicate validation of videos in selected videos list. <br>" +
          "Adding numberical orders to the selected Videos. <br>" +
          "Adding dynamic calculation of page numbers. <br>" +
          "Adding not found alert on YouTube Results. <br>" +
          "Adding no videos added info on selected Videos. <br>" +
          "Mapping Series Information together. <br>" +
          "Series Information sync from Channel information. <br>" +
          "Show Series technical Information. <br> "
    },

    {
        title: 'v0.4.4',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "Upgrading Dummy Mode Requests to Advanced Search Results (ASR). <br>" +
          "Refining YouTube Requests Data. <br>" +
          "Performing paginated Requests. <br>" +
          "Handling paginated Requests within Storage. <br>" +
          "Due the missing direct page navigation from YT, we'll skip <br>" +
          "that and move on a endless scrolling navigation... as for now we <br>" +
          "got a hybird solution that is working well. Still wondering about <br>" +
          "YouTube's token variables. <br>"
    },

    {
        title: 'v0.4.3',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "Update additional Tab Views. <br> " +
          "Adding selected Videos for Series. <br>" +
          "Order Videos by drag & drop in their order. <br>" +
          "Adding smooth transition animations between the dragging. <br>" +
          "Synchronising the mutated data to the store. <br>" +
          "lemme thing about another custom data mapping for YT Objects... <br>"
    },

    {
        title: 'v0.4.2',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "Adding Vuex Storage System. <br>" +
          "Implementing separate Storage Module for YTM. <br>" +
          "Synchronising Data between Storage and Components. <br>"
    },

    {
        title: 'v0.4.1',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "Update of YouTube Managing Editor [YTM|Editor]. <br>" +
          "Nicely formatting the results of YouTube API. <br>" +
          "Creating and extending Debug and Dummy Mode. <br>" +
          "Adding functional interaction components to handle items. <br>" +
          "Splitting the data into components and views. <br>" +
          "Adding Tab Views for search and content area. <br>" +
          "Prepare Series Data Structure for Selected Videos. <br>" +
          "Prepare Series Information Mask with Thumbnail preview. <br>"
    },

    {
        title: 'v0.4.0',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "Creating the YouTube Managing Editor [YTM|Editor]. <br>" +
          "First prototype Endpoints to YouTube and gathering exampels. <br>" +
          "Analyse of YouTube Responses and Custom Driver Mapping for the Endpoints.<br>" +
          "Mapping YTM|Editor selectables to convertable objects in YTM. <br>"
    },

    {
        title: 'v0.3.0',
        subtitle: 'Mai 2020',
        side: 'left',
        icon: false,
        content:
          "Upgrading Video finding logic. <br>" +
          "Performance boost for Thubmnail sources. <br>" +
          "Cloning of Thumbnails for better performance and management. <br>" +
          "fixing home page view. <br>" +
          "verifiying image url based on path and url. <br>" +
          "Modifying og:meta tags for shareable content. <br>" +
          "Adding shareable screenshot. <br>"
    },

    {
        title: 'v0.2.2',
        subtitle: 'Mai 2020',
        side: 'right',
        icon: false,
        content:
          "Adding Apps dropdown. <br>" +
          "Adding User dropdown. <br>" +
          "fixing mobile font sizes. <br>"
    },

    {
        title: 'v0.2.1',
        subtitle: 'April 2020',
        side: 'left',
        icon: false,
        content:
          "Add ability to apply user ID to searched video. <br>" +
          "Each Video can be found therefore also in their user history. <br>" +
          "Add ability to regex the Video ID out of the YouTube Full Path. <br>" +
          "Add some example links to the about page. <br>"
    },

    { headline: "YouTube Manager [YTM] is born" },

    {
        title: 'v0.2.0',
        subtitle: 'April 2020',
        side: 'right',
        icon: false,
        content:
          "Rebuilding YTC according to the new PSR and ES2018 Standards. <br>" +
          "Change source layout code to a more stable and mature framework. <br>" +
          "Recreating Overlaying components and elements. <br>" +
          "Integrating SSO Authentication for users. <br>" +
          "Handling a bigger purpose with YTC, so renaming it to YouTube Manager [YTM]. <br>"
    },

    {
        title: 'v0.1.3',
        subtitle: 'Winter 2019',
        side: 'left',
        content:
          "First prototype Module created with user authentication <br>" +
          "Got working module implemented in different Software versions. <br>" +
          "Adding 3rd party support. <br> "
    },

    {
        title: 'v0.1.2',
        subtitle: 'Autumn 2019',
        side: 'right',
        content:
          "Implementing YTC in a real Single Page Application for global usage. <br>" +
          "Extending Thumbnail Information like size, quality, download, category... <br>" +
          "First  prototype Module created with oAuth implementation <br>" +
          "Got working prototype with JWT Tokens."
    },

    {
        title: 'v0.1.0',
        subtitle: 'Sommer 2019',
        side: 'left',
        icon: 'emoji_objects',
        content:
          "Got the idea about catching YouTube Thumbnails of specific video genres. <br>" +
          "Researching about the YouTube Endpoints and Workflows how to catch them. <br>" +
          "Building the very first and simplest Thumbnail Catcher for own purposes. <br>" +

          "First  prototype Module created with oAuth implementation <br>" +
          "Got working prototype with JWT Tokens "
    },

    { 
        headline: 'YouTube Catcher [YTC] created'
    },

]
